import { Link } from "react-router-dom";
import { EVENTS, categories } from "@/mocks/events";
import NewsletterForm from "./NewsletterForm";

export default function SiteFooter() {
  const hotEvents = [...EVENTS].sort((a, b) => b.heat - a.heat).slice(0, 4);

  return (
    <footer className="bg-background-100" aria-label="页脚">
      {/* 订阅追瓜区 */}
      <div
        id="subscribe"
        className="mx-auto w-full scroll-mt-24 bg-primary-500"
      >
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-6 px-4 py-12 md:flex-row md:items-center md:justify-between md:px-6 lg:py-16">
          <div className="max-w-xl">
            <p className="flex items-center gap-2 text-sm font-medium text-primary-100">
              <span className="live-dot h-2 w-2 rounded-full bg-background-50"></span>
              追瓜小助手 · 每周瓜报
            </p>
            <h2 className="mt-3 font-display text-2xl text-background-50 md:text-3xl">
              别等热搜告诉你，让瓜先来找你
            </h2>
            <p className="mt-2 text-sm leading-relaxed text-primary-100/90">
              留下邮箱，我们会在重要事件发酵的第一时间，把「来龙去脉 + 完整时间线」的深度梳理发送给你，帮你省下翻遍全网的功夫。
            </p>
          </div>
          <div className="w-full md:max-w-md">
            <NewsletterForm />
          </div>
        </div>
      </div>

      {/* 主体链接区 */}
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid grid-cols-2 gap-8 md:grid-cols-4">
          {/* 品牌介绍 */}
          <div className="col-span-2 md:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-display text-lg text-background-50">
                瓜
              </span>
              <span className="font-display text-lg text-primary-700">吃瓜资讯</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              不止于爆料。我们专注热点事件梳理、来龙去脉还原与背后真相的深度解析，
              用完整时间线帮你把复杂瓜局看得明明白白。
            </p>
            <div className="mt-5 flex items-center gap-2">
              {["ri-weibo-line", "ri-wechat-line", "ri-douban-line", "ri-youtube-line"].map(
                (icon) => (
                  <a
                    key={icon}
                    href="#subscribe"
                    onClick={(e) => e.preventDefault()}
                    aria-label="关注吃瓜资讯"
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    <i className={`${icon} text-lg`}></i>
                  </a>
                ),
              )}
            </div>
          </div>

          {/* 栏目导航 */}
          <nav aria-label="页脚栏目">
            <h3 className="text-sm font-bold text-foreground-900">栏目速览</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li>
                <a href="#hot" className="transition-colors hover:text-primary-600">
                  今日热榜
                </a>
              </li>
              <li>
                <a href="#latest" className="transition-colors hover:text-primary-600">
                  最新速览
                </a>
              </li>
              <li>
                <a href="#deep" className="transition-colors hover:text-primary-600">
                  深度解析
                </a>
              </li>
              <li>
                <a href="#topics" className="transition-colors hover:text-primary-600">
                  分类热词
                </a>
              </li>
              <li>
                <a href="#about" className="transition-colors hover:text-primary-600">
                  关于我们
                </a>
              </li>
            </ul>
          </nav>

          {/* 热门瓜 */}
          <nav aria-label="热门事件">
            <h3 className="text-sm font-bold text-foreground-900">本周热瓜</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              {hotEvents.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/story/${item.id}`}
                    className="line-clamp-1 transition-colors hover:text-primary-600"
                  >
                    {item.hotTitle}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>

          {/* 分类与联系 */}
          <nav aria-label="事件分类">
            <h3 className="text-sm font-bold text-foreground-900">分类热词</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              {categories
                .filter((c) => c.key !== "全部")
                .slice(0, 4)
                .map((c) => (
                  <li key={c.key}>
                    <a href="#topics" className="transition-colors hover:text-primary-600">
                      {c.key}
                    </a>
                  </li>
                ))}
              <li>
                <a
                  href="mailto:hello@chigua.example"
                  className="inline-flex items-center gap-1.5 text-foreground-700 transition-colors hover:text-primary-600"
                >
                  <i className="ri-mail-line" aria-hidden="true"></i>
                  hello@chigua.example
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>

      {/* 版权栏 */}
      <div className="border-t border-background-200">
        <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-foreground-500 sm:flex-row md:px-6">
          <p>© 2026 吃瓜资讯 · 让每一个瓜都有来龙去脉</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-verified-badge-line text-primary-500" aria-hidden="true"></i>
            事件梳理 · 多源交叉求证 · 中立呈现
          </p>
        </div>
      </div>
    </footer>
  );
}